import routes from '@/routes';
import UserManager from '@/services/user-manager/user-manager';
import store from '@/store';
import Vue from 'vue';
import Router, { Route } from 'vue-router';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [...routes],
});

router.afterEach((to, from) => {
    document.title = `${to.meta.title} - Right Legal Group`;
});
router.beforeEach(async (to, from, next) => {
    await UserManager.clearStaleState();
    const user = await UserManager.getUser();

    const isLoggedIn = user != null;

    if ((!isLoggedIn || user!.expired) && to.meta.requiresAuthentication) {
        await UserManager.signinRedirect();
        return;
    }

    if (to.meta.requiresAuthentication || (to.meta.requiresAnyRole != null && to.meta.requiresAnyRole.length > 0)) {
        const routeCheck: (route: Route) => boolean = store.getters['user/hasPermissionForRoute'];

        if (!routeCheck(to)) {
            next({ name: 'forbidden' });
            return;
        }
    }
    next();
});

export default router;
